import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createArbitrationProceedingAPI,
  updateArbitrationProceedingAPI,
  deleteArbitrationProceedingAPI,
  getArbitrationProceedingsByCaseIDAPI,
  getArbitrationProceedingAPI,
} from "../../../api/arbitrationProceedings_api";

export const getArbitrationProceedingsByCaseIDAction = createAsyncThunk(
  "arbitrationProceedings/getByCase",
  async (caseID, { rejectWithValue }) => {
    const response = await getArbitrationProceedingsByCaseIDAPI(caseID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data; // Note: We return response.data directly (which is already serializable)
  }
);

export const createArbitrationProceedingAction = createAsyncThunk(
  "arbitrationProceedings/create",
  async (proceedingData, { rejectWithValue }) => {
    const response = await createArbitrationProceedingAPI(proceedingData);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  }
);

export const updateArbitrationProceedingAction = createAsyncThunk(
  "arbitrationProceedings/update",
  async ({ id, proceedingData }, { rejectWithValue }) => {
    const response = await updateArbitrationProceedingAPI(id, proceedingData);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  }
);

export const deleteArbitrationProceedingAction = createAsyncThunk(
  "arbitrationProceedings/delete",
  async (id, { rejectWithValue }) => {
    const response = await deleteArbitrationProceedingAPI(id);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return id;
  }
);

export const getArbitrationProceedingAction = createAsyncThunk(
  "arbitrationProceedings/get",
  async (id, { rejectWithValue }) => {
    const response = await getArbitrationProceedingAPI(id);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  }
);
